import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=d3a459c0&scoped=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenPage.vue?vue&type=style&index=0&id=d3a459c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a459c0",
  null
  
)

export default component.exports